import { render, staticRenderFns } from "./CompanySwitcher.vue?vue&type=template&id=896c208a&scoped=true"
import script from "./CompanySwitcher.vue?vue&type=script&lang=js"
export * from "./CompanySwitcher.vue?vue&type=script&lang=js"
import style0 from "./CompanySwitcher.vue?vue&type=style&index=0&id=896c208a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896c208a",
  null
  
)

export default component.exports